// extracted by mini-css-extract-plugin
export default {"hero_card_wrapper":"HeroCard_hero_card_wrapper__NN9wu","hero_card":"HeroCard_hero_card__tBSTN","benefits_section_wrapper":"HeroCard_benefits_section_wrapper__hw0l5"};